export const defaultPlaneColor = 0xffffff;
export const glassPlaneColor = 0x88ccff;
